module.exports = ".mt10 {\n  margin-top: 10px; }\n\n.mb10 {\n  margin-bottom: 10px; }\n\n.mb25 {\n  margin-bottom: 25px; }\n\n.login-page {\n  margin: 10% auto; }\n\n.information-message-toaster {\n  background-color: #f7ad06;\n  font-size: 0.9em;\n  font-weight: 600;\n  z-index: 999999;\n  word-break: break-word; }\n\n.p-25 {\n  padding: 25px !important; }\n\n.mt-20 {\n  margin-top: 20px !important; }\n\n.mb-20 {\n  margin-bottom: 20px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/non-auth/login/login.component.scss
// module id = ./src/app/modules/non-auth/login/login.component.scss
// module chunks = non-auth.module